import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/questionnaire/plan/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/questionnaire/plan/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/v4ward/questionnaire/plan/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/questionnaire/plan/save', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/questionnaire/plan/update', params, options);

export const getPlanTopicIdListByPlanId = (params, options) =>
  request.get('/api/v4ward/questionnaire/plan/getPlanTopicIdListByPlanId', Object.assign({}, options, { params }));

export const getPlanTopicListByPlanId = (params, options) =>
  request.get('/api/v4ward/questionnaire/plan/getPlanTopicListByPlanId', Object.assign({}, options, { params }));

// 获取用户列表-人员选择
export const getProjectUserList = (params, options) =>
request.get('/api/v4ward/user/project-user-list', Object.assign({}, options, { params }));
